export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c0b85c99-114f-4e8c-9532-b3c0658fe1ca';
export const MODAL_CLOSE_SEC = 2.5;
